<template>
  <div class="tempNotice">
    <div class="tempNotice-t">关于“小程序”升级维护 暂停使用服务的通知</div>
    <div class="tempNotice-c"><img src="./img/info.png" alt="" /></div>
    <div class="tempNotice-b">
      因“明珠助手”小程序升级维护，所有服务功能暂停使用，停用时间2022年12月12日（周一）12：00--2022年12月14日（周三）19：00，升级维护期间有关场地预定请联系13216693577（吴女士），给您带来不便敬请谅解！
    </div>
    <div class="time">2022年12月12日</div>
    <!-- <v-h5Mtml :content="detail.neighborhoodText"></v-h5Mtml> -->
  </div>
</template>

<script>
import { getNeighborhoodConventionUrl } from "./api.js";
export default {
  name: "tempNotice",
  data() {
    return {
      detail: {
        neighborhoodText: `<p>	<strong>一、实木地板</strong></p><p>	是由天然木材经烘干、加工后形成的，又称原木地板。</p><p>	优点:纹理自然;环保;冬暖夏凉，触感好，弹性好;有良好隔音、吸音、绝缘性能;可翻新。</p><p>	缺点:不耐磨，易失去光泽;不宜在湿度变化较大的地方使用，否则易变形;怕酸、碱等化学品腐蚀，怕灼烧。适宜铺设场所:普通住宅的卧室、客厅、书房等。</p><p>	<strong>二、强化地板</strong></p><p>	也称浸渍纸层压木质地板，由耐磨层、装饰层、高密度基材层、平衡(防潮)层组成。</p><p>	优点:价格选择范围大，适用范围广;花色品种多;耐	污、抗酸碱性好，易维护;防滑性能好;耐磨、抗菌，不会虫蛀、霉变;不受温度、湿度影响变形;防火性能好;重量轻，减轻建筑的承载;铺设方便。</p><p>	缺点:脚感没有实木地板好;可修复性差;存在一定的甲醛释放问题。适宜铺设场所:普通住宅、公共场所</p><p>	<strong>三、实木复合地板</strong></p><p>	将优质实木锯切刨切成表面板、蕊板和底板单片，然后将三种单片依照纵向、横向、纵向三维排列方法，用胶水粘贴起来，并在高温下压制成板，分三层和多层二种。三层实木复合地板表层为优质名贵木材薄片，中间和底层为速生木材，用胶水热压而成;多层实木复合地板以多层胶合板为基材，表层为硬木片镶拼板或刨切单板，以胶水热压而成。</p><p>	优点:自然美观，脚感舒适;耐磨、耐热、耐冲击;阻燃、防霉、防蛀;隔音、保温;不易变形;铺设方便。</p><p>	缺占:如胶合 七圳照的的现象:表层较薄，使用中必须重视维护保养。适宜铺设场所:普通住宅的卧室、客厅、书房等。在地热环境中，多层实木地板耐热性强，更不易变形。因此如果是地热用地板，就一定要选择多层实木复合地板。</p><p>	<strong>四、竹地板</strong></p><p>	采用胶粘剂将竹板拼接，并施以高温高压而成的地板。</p><p>	优点:格调清新高雅，装饰效果好;色差较小;冬暖夏凉;环保无污染;防蛀、防霉。</p><p>	缺点:会随气候干湿度变化而变形。适宜铺设场所:普通住宅、宾馆、写字楼等。</p><p>	<strong>五、软木地板</strong></p><p>	软木是生长在地中海沿岸和我国秦岭地区的橡树，而软木制品的原料就是橡树的树皮。软木地板就是以这种材。</p><p>	优点:弹性、防滑性好;保温性好，脚感舒适;隔音性好，可以吸收生活噪音，创造安静的生活环境;花色比较个性。</p><p>	缺点:价格较高，市场不成熟。适宜铺设场所:卧室、会议室、图书馆、录音棚等场所</p><p>	<strong class="ql-size-large">木地板选购注意事项</strong></p><p>	<strong>一、实木地板可简单地分为浅色材质和深色材质</strong></p><p>	浅色材质的色彩均匀，风格明快，能充分烘托家庭温馨气氛。深色材质的色差大，年轮变化明显，具有膨胀系数较小、防水、防虫的特性，其中比较珍贵、稀少的有香脂木豆、柚木、吕柄桑、非洲缅茄等;稳定性较好的有蚁木(伊贝)、孪叶苏木、萨佩莱、塔利、铁苏木、印茄、双柱苏木等;木材纹理清晰的有玉蕊木等;色差较大的有蚁木(伊贝)、香二翅豆等;价廉物美、市场旺销的有甘巴豆等。</p><p>	<strong>二、选颜色优质的实木地板应有自然的色调，清晰的木纹</strong></p><p>	如里地板麦面颜鱼深重，漆层较厚，则可能是为掩饰地板表面缺陷而有意为之，当地板为六面封漆时尤需注意。同时，由于地板块在其母体--树木中所处的位置不同，有边材、心材、木表、木里、阴面、阳面的差异，且板材的切割方式有弦切、径切的分别，故色差必然存在。正是色差、天然的纹理、富有变化的肌理结构，彰显了实木地板的自然风采。国际上的家居装饰现在流行色差巨大，长短不齐、材种多样的风格。随着我国消费者环境意识的增强，以后必然趋向于这种装修。</p><p><img src="http://obs-xmjdmzsq1.obs.zjlt-dc-2.zjwocloud.com/upload/20221122/903f380ee7dca776ce08648889bbbbbc.jpg"></p><p>	<strong>三、选尺寸大小从木材的稳定性来说，地板的尺寸越小，抗变形能力越强。</strong></p><p>	市场上流行宽板，宽板较窄板来说更为美观、大方，纹理舒张，花纹完整，但合格的宽板须经过严格的材种挑选和质量验收。</p><p>	<strong>四、选含水率由于全国各城市所处地理位置不同，所需木材的含水率各不相同。</strong></p><p>	购买时可向专业销售人员咨询，以便购买到含水率与当地平衡含水率相均衡的地板。</p><p>	<strong>五、选加工精度用几块地板在平地上拼装，用手摸、眼看其加工质量精度、光洁度，是否平整、光滑，榫槽配合、安装缝隙、抗变性槽等拼装是否严丝合缝。好地板应该做工精密，尺寸准确，角边平整，无高低落差。</strong></p><p><img src="http://obs-xmjdmzsq1.obs.zjlt-dc-2.zjwocloud.com/upload/20221122/bc08d7f257a349e3b07c5224dfba2ae7.jpg"></p><p>	<strong>六、选木材质量实木地板采用天然木材加工而成，其表面有活节、色差等现象均属正常。</strong></p><p>	同时，这也正是实木地板不同于复合地板的自然之处，故不必太过苛求。如表面有虫眼、开裂、腐朽、蓝变、死节等缺陷，在施工时可根据铺设需要，或截短，或锯成两半，取其可用而去其缺陷。</p><p>	<strong>七、选油漆质量不论亮光或哑光漆地板，挑选时均应观察表面漆膜是否均匀、丰满、光洁，有无漏漆、鼓泡、孔眼。</strong></p><p>	油漆分UV、PU两种。可向销售人员询问地板的油漆类型。一般来说，含油脂较高的地板如柚木、蚁木(伊贝)、紫心苏木等需要用PU漆，用UV漆会出现脱漆起壳现象。PU漆面色彩真实，纹理清晰，如有破损易于修复。PU漆由于干燥时间长，所需加工期也长。此外，PU漆地板的价格会比UV漆地板的价格稍高一点。</p>`,
      },
    };
  },
  computed: {
    userId() {
      return this.$store.state.userId;
    },
    communityId() {
      return this.$store.state.communityId;
    },
  },
  async mounted() {
    // this.getContent();
  },
  methods: {
    getContent() {
      //获取合约内容
      let params = {
        houseId: this.communityId,
      };
      this.$axios
        .get(`${getNeighborhoodConventionUrl}`, {
          params: params,
        })
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.detail.neighborhoodText = res.data.neighborhoodText;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.tempNotice {
  padding: 134px 42px;
  .tempNotice-t {
    text-align: center;
    padding: 0 140px;
    font-size: 38px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 52px;
  }
  .tempNotice-c {
    width: 400px;
    height: 400px;
    margin: 44px auto 42px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tempNotice-b {
    text-indent: 2em;
    font-size: 30px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 48px;
  }
  .time {
    margin-top: 56px;
    text-align: right;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 40px;
  }
}
</style>
